import { Link } from 'react-router-dom'
import React, { Component } from 'react'
import './index.scss'

export class index extends Component {
  static defaultProps = {
    titleIshow: true
  }

  state = {}
  componentWillMount() {}

  render() {
    return (
      <div style={{ width: '100%', backgroundColor: 'white' }}>
        <div className="mytypeArea We" style={{ margin: '0 auto' }}>
          {this.props.titleIshow && (
            <div className="We-title">
              <div className="We-title-h1">关于我们</div>
              <div className="We-title-text">ABOUT US</div>
            </div>
          )}

          <div className="We-content">
            <div className="We-content-text">
              <div className="We-content-text-title">北京锐控自动化科技有限公司</div>
              <div className="We-content-text-message" style={{textIndent: '2em'}}>
                <p>
                北京锐控自动化科技有限公司（简称：锐控科技），创立于2015年，注册资本2000万元。总部位于北京市大兴区中关村示范区园区——格雷众创园，并在武汉设有研发中心和办事处。锐控科技聚焦产业互联网，助力企业和政府数字化转型，并在数字生活、数字城市、数字能源、工业互联网等领域进行技术成果转化。
                </p>
                <p>
                锐控科技高度重视自主研发和科研队伍建设，并联合哈尔滨理工大学测控技术与通信工程学院、哈尔滨工业大学计算机学院多智能体机器人研究中心成立了专家委员会。经过研发团队的不懈努力，已自主研发了多项核心产品，拥有二十余项软件著作权及发明专利。2022年，公司被认定为北京市知识产权试点单位，先后荣获国家高新技术企业和中关村高新技术企业称号，并通过了国军标质量管理体系认证及CNAS质量管理体系认证。
                </p>
                {/* <p>
                锐控科技持续关注用户体验和产品安全的不断提升，以其优质的产品和服务赢得了航天科技集团、航天科工集团、中国科学院、民政部、北京市地质工程勘察院等众多客户的信赖与好评。
                </p>
                <p>
                锐控科技秉承积极务实的企业精神，始终坚持“真诚服务、追求卓越”的企业理念，以数智科技赋能产业升级、提升用户体验，创造新价值，以技术研发和产品作为企业发展驱动力，以专注、专业、扎实的工作态度，在核心技术方向不断深耕，持续钻研，为打造繁荣的工业互联网生态贡献力量。
                </p> */}
              </div>
              <div className="We-content-text-botton">
                <Link to="/aboutus/honorary.html">
                  <div className="We-content-text-botton-item zizhibox">
                    <div className="We-content-text-botton-item-img zizhi" alt=""></div>
                    <span className="We-content-text-botton-item-text">荣誉资质</span>
                  </div>
                </Link>

                <Link to="/aboutus/ecology.html">
                  <div className="We-content-text-botton-item shengtaibox">
                    <div className="We-content-text-botton-item-img shengtai" alt=""></div>
                    <span className="We-content-text-botton-item-text">锐控生态</span>
                  </div>
                </Link>
                <Link to="/aboutus/idea.html">
                  <div className="We-content-text-botton-item kejibox">
                    <div className="We-content-text-botton-item-img keji" alt=""></div>
                    <span className="We-content-text-botton-item-text">科技创新</span>
                  </div>
                </Link>
              </div>
            </div>
          
            <img className="We-content-image" src={require('../../../image/message.png')}></img>
          </div>
        </div>
      </div>
    )
  }
}

export default index
